const ReportsPermissionAlert = () => (
  <div className='container mx-auto px-4 py-6'>
    <div className='rounded-lg border border-dashed border-border p-8 text-center'>
      <p className='text-sm font-medium text-foreground'>
        No reports available
      </p>
      <p className='mt-1 text-sm text-muted-foreground'>
        Ask your administrator if you need a report added to your account.
      </p>
    </div>
  </div>
);

export default ReportsPermissionAlert;
